import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { IEntityResolver, Key } from '@kpd/framework-ngx';
import { Permission } from 'app/shared/models/permission';
import { PermissionService } from 'app/shared/services/permission.service';

@Injectable()
export class PermissionEntityResolver implements IEntityResolver<Permission> {
  constructor(private permissionService: PermissionService) {}

  resolve(params: { id: string; type?: string }): Observable<Permission> {
    if (params.id === '0') {
      return of(new Permission());
    }
    const key = Key.composeKeyByRouteParams(params);
    return this.permissionService.getById(key as Key<string>);
  }
}
